import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // apiHost: 'https://test.aigcpop.com',
    apiHost: 'https://dt.aigcpop.com', // https://120.26.103.140:443 https://test.aigcpop.com https://dt.aigcpop.com
    // pc：'https://multishop.meuagi.com/home'
    // pc：'http://localhost:9527/home' http://localhost:3000/home
    // pc：测试服 http://test.aigcpop.com:18087/home
    // mobile: https://multishop-h5.meuagi.com/pages/login/login http://localhost:80/pages/login/login
    // mobile：测试服 http://test.aigcpop.com:18089/pages/login/login
    // 新版pc改为home
    shopHost: 'https://multishop.meuagi.com/home',
    isMeuHost: false, // 为真则展示meu的备案号和不显示登录按钮 和 登录验证提示
    userAuth: localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')) : { // localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')) :
      username: '',
      password: '',
      userToken: '',
      accessToken: '',
      haveLogin: false
    },
    showPanel: false,
    project0: localStorage.getItem('project0') ? JSON.parse(localStorage.getItem('project0')) : {
      'ai_prompt': '',
      'comment': '默认项目',
      'db_prompt': '你是我的小助手，会帮我回答一些用户提问',
      'engine': 'ai',
      'id': -1,
      'max_tokens': 2048,
      'model': 'gpt-3.5-turbo',
      'name': '默认项目-',
      'owner': ''
    },
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {
      mall_state: -1
    },
    isMobile: false
  },
  mutations: {
    updateMobile (state, value) {
      state.isMobile = value
    },
    updateUserAuth (state, value) {
      state.userAuth = value
      localStorage.setItem('userAuth', JSON.stringify(state.userAuth))
    },
    updateShowPanel (state, value) {
      state.showPanel = value
    },
    updateUserInfo (state, value) {
      state.userInfo = value
      localStorage.setItem('userInfo', JSON.stringify(value))
    },
    updateProject0 (state, value) {
      state.project0 = value
      localStorage.setItem('project0', JSON.stringify(state.project0))
    },
    updateIsMeu (state, value) {
      state.isMeuHost = value
    }
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js